(function () {
  'use strict';

  var loaderSelector = 'script[src*="cdn.reamaze.com/assets/reamaze.js"]';
  var loadingTimeout = 12000;

  function labelEmbeddedForm(target) {
    var title = target.getAttribute('data-sw-reamaze-title');
    var frames = target.querySelectorAll('iframe');

    if (!title || frames.length === 0) return false;

    Array.prototype.forEach.call(frames, function (frame) {
      frame.title = title;
    });

    return true;
  }

  function showReady(section) {
    var shell = section.querySelector('[data-sw-contact-form-shell]');
    var fallback = section.querySelector('[data-sw-contact-fallback]');

    if (!shell) return;

    shell.classList.remove('is-error');
    shell.classList.add('is-ready');
    if (fallback) fallback.hidden = true;
  }

  function showFallback(section) {
    var shell = section.querySelector('[data-sw-contact-form-shell]');
    var target = section.querySelector('[data-sw-reamaze-target]');
    var fallback = section.querySelector('[data-sw-contact-fallback]');

    if (!shell || (target && target.children.length > 0)) return;

    shell.classList.remove('is-ready');
    shell.classList.add('is-error');
    if (fallback) fallback.hidden = false;
  }

  function watchForm(section) {
    var target = section.querySelector('[data-sw-reamaze-target]');

    if (!target) return;
    if (target.children.length > 0) {
      showReady(section);
    }

    if (labelEmbeddedForm(target)) return;

    var observer = new MutationObserver(function () {
      if (target.children.length > 0) {
        showReady(section);
      }

      if (labelEmbeddedForm(target)) {
        observer.disconnect();
      }
    });

    observer.observe(target, { childList: true, subtree: true });

    window.setTimeout(function () {
      observer.disconnect();
      showFallback(section);
    }, loadingTimeout);
  }

  function reloadReamaze(section) {
    if (window.Reamaze && typeof window.Reamaze.reload === 'function') {
      window.Reamaze.reload();
    }
    watchForm(section);
  }

  function initializeSection(section) {
    if (!section || section.dataset.swContactInitialized === 'true') return;

    var account = section.getAttribute('data-reamaze-account');
    if (!account) {
      showFallback(section);
      return;
    }

    section.dataset.swContactInitialized = 'true';
    window._support = window._support || { ui: {}, user: {} };
    window._support.ui = window._support.ui || {};
    window._support.user = window._support.user || {};
    window._support.account = account;

    var existingLoader = document.querySelector(loaderSelector);
    if (window.Reamaze && typeof window.Reamaze.reload === 'function') {
      reloadReamaze(section);
      return;
    }

    if (existingLoader) {
      existingLoader.addEventListener('load', function () {
        reloadReamaze(section);
      }, { once: true });
      existingLoader.addEventListener('error', function () {
        showFallback(section);
      }, { once: true });
      watchForm(section);
      return;
    }

    var loader = document.createElement('script');
    loader.src = 'https://cdn.reamaze.com/assets/reamaze.js';
    loader.async = true;
    loader.setAttribute('data-sw-reamaze-loader', '');
    loader.addEventListener('load', function () {
      reloadReamaze(section);
    }, { once: true });
    loader.addEventListener('error', function () {
      showFallback(section);
    }, { once: true });
    document.body.appendChild(loader);
    watchForm(section);
  }

  function initializeAll(root) {
    var scope = root || document;
    var sections = scope.matches && scope.matches('[data-sw-contact]')
      ? [scope]
      : scope.querySelectorAll('[data-sw-contact]');

    Array.prototype.forEach.call(sections, initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAll(document);
    }, { once: true });
  } else {
    initializeAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event.target);
  });
})();
